import React from 'react';
import ReactDOM from 'react-dom';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import NationalParks from './NationalParks';

const App = () => {
  return (
    <Routes>
        <Route exact path="/national-parks/:state" element={<NationalParks />} />
    </Routes>
  )
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <BrowserRouter>  
        <App />
    </BrowserRouter>,
    document.getElementById('national-parks-container'),
  )
})